import { render, staticRenderFns } from "./manual-table.vue?vue&type=template&id=48cefa46&scoped=true&"
import script from "./manual-table.vue?vue&type=script&lang=js&"
export * from "./manual-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cefa46",
  null
  
)

export default component.exports